<template>
  <div class="coache-head-blk" id="my-tournament">
    <div class="row align-items-center">
      <div class="col-md-5">
        <div class="court-table-head">
          <h4>Giải đấu của bạn</h4>
          <p>Quản lý và điều chỉnh giải đấu của bạn: {{ totalTournaments }} giải đấu</p>
        </div>
      </div>
      <div class="col-md-7">
        <div class="table-search-top">
          <div id="tablefilter">
            <div class="dataTables_filter">
              <label>
                <input v-model="keyword" class="form-control form-control-sm" placeholder="Tìm kiếm"
                       type="search">
              </label>
            </div>
          </div>
          <div class="request-coach-list">
            <div class="card-header-btns">
              <nav>
                <div class="nav nav-tabs" role="tablist">
                  <button class="nav-link active" type="button" @click="searchKeyword">
                    Tìm kiếm
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
      id="nav-Recent"
      aria-labelledby="nav-Recent-tab"
      class="tab-pane fade show active"
      role="tabpanel"
      tabindex="0"
  >
    <div class="table-responsive table-datatble">
      <a-table :columns="columns" :data-source="data" class="table datatable">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'Name'">
            <h2 class="table-avatar">
              <a class="avatar avatar-sm flex-shrink-0" href="javascript:void(0);"
              ><img :src="record.Image"
                    alt="User"
                    class="avatar-img"
              /></a>
              <span class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" @click="openModal(record.originData ?? '')">
                  {{ record.Name }}</a>
                <span>Thi đấu: {{ record.Category }}</span>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Date'">
            <div class="table-date-time">
              <h4>
                {{ record.Date }}
              </h4>
            </div>
          </template>
          <template v-else-if="column.key === 'Total'">
            <div>
              <span class="pay-dark fs-16">{{ record.Total }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'Status'">
            <span :class="record.Class"
            ><i class="feather-check-square me-1"></i>{{ record.Status }}</span
            >
          </template>
        </template>
      </a-table>
    </div>
  </div>

  <div class="tab-footer">
    <div class="row">
      <div class="col-md-6">
        <div id="tablelength">
          <div class="dataTables_length">
            <label>Hiển thị
              <select
                  v-model="size"
                  class="custom-select custom-select-sm form-control form-control-sm"
                  @change="handleTableChange"
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="999999">All</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div id="tablepage">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                  :class="{ disabled: current === 1 }"
                  class="paginate_button page-item previous"
                  @click="changePage(current - 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-left"></i>
                </a>
              </li>

              <li
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: current === page }"
                  class="paginate_button page-item"
                  @click="changePage(page)"
              >
                <a class="page-link" href="javascript:void(0);">{{ page }}</a>
              </li>

              <li
                  :class="{ disabled: current === totalPages }"
                  class="paginate_button page-item next"
                  @click="changePage(current + 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <TournamentModal v-model:visible="showModal" :initialData="initialData"
                   :style="{ width: '50%', minWidth: '600px' }"/>
</template>
<script setup>
import { useQuery } from "@vue/apollo-composable";
import { ref, watch, computed } from "vue";
import TournamentModal from "@/components/modal/tournament-detail-modal.vue";
import { GET_TOURNAMENT_BY_PLAYER } from "@/graphql/operations/tournament.ts";

const url = process.env.VUE_APP_SERVER_URL;
const keyword = ref("");
const data = ref([]);
const showModal = ref(false);
const initialData = ref(null);

const columns = [
  {
    title: "Tên giải",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.Name.toString().toLowerCase();
        b = b.Name.toString().toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Từ ngày - đến ngày",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toString().toLowerCase();
        b = b.Date.toString().toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Số vđv",
    dataIndex: "Total",
    key: "Total",
    sorter: {
      compare: (a, b) => {
        a = a.Total.toString().toLowerCase();
        b = b.Total.toString().toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toString().toLowerCase();
        b = b.Status.toString().toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Thao tác",
    key: "action",
    sorter: true,
  },
];

const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true,
});

const player = JSON.parse(localStorage.getItem("player"));
const playerId = player?.documentId ?? "";

const { result: resultTournament, refetch } = useQuery(
    GET_TOURNAMENT_BY_PLAYER,
    () => ({
      documentId: playerId,
      page: parseInt(pagination.value.current),
      pageSize: parseInt(pagination.value.pageSize),
      keyword: keyword.value,
    }),
    { fetchPolicy: "network-only" }
);

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

watch(
    resultTournament,
    () => {
      if (resultTournament.value?.tournaments_connection) {
        const tournamentDatas = resultTournament.value.tournaments_connection.nodes ?? [];
        pagination.value.total = resultTournament.value.tournaments_connection.pageInfo.total;

        data.value = tournamentDatas.map((tournamentData) => {
          const statusMap = {
            upcoming: { text: "Sắp diễn ra", class: "badge bg-info" },
            pending: { text: "Chờ diễn ra", class: "badge bg-warning" },
            ongoing: { text: "Đang diễn ra", class: "badge bg-primary" },
            finished: { text: "Đã kết thúc", class: "badge bg-success" },
            canceled: { text: "Đã huỷ", class: "badge bg-danger" },
          };

          const categoryMap = {
            DM: "Đôi nam",
            DW: "Đôi nữ",
            SM: "Đơn nam",
            SW: "Đơn nữ",
            XD: "Đôi nam nữ",
          };

          let categories = [];

          try {
            const raw = tournamentData?.contain_categories;
            categories = typeof raw === "string" ? JSON.parse(raw) : Array.isArray(raw) ? raw : [];
          } catch (e) {
            console.error(e);
            categories = [];
          }

          const categoryItem =
              (categories.length > 0
                  ? categories
                      .filter((item) => categoryMap[item])
                      .map((item) => categoryMap[item])
                      .join(", ")
                  : tournamentData?.categories
                      ?.map((category) => category?.name || "Không có hình thức thi đấu")
                      .join(", ")) || "Không có hình thức thi đấu";

          return {
            key: tournamentData.documentId,
            Name: tournamentData?.name,
            DateStart: tournamentData?.date_start,
            Date: `${formatDate(tournamentData?.date_start)} ~ ${formatDate(tournamentData?.date_end)}`,
            Total: tournamentData?.num_player,
            Status: statusMap[tournamentData?.tour_status]?.text || "Không xác định",
            Category: categoryItem,
            Attend: "Xem kết quả",
            Class: statusMap[tournamentData?.tour_status]?.class || "",
            Image: url + tournamentData?.photo.url,
            originData: tournamentData,
          };
        });
      } else {
        data.value = [];
        pagination.value.total = 0;
      }
    },
    { deep: true }
);

const totalPages = computed(() => Math.ceil(pagination.value.total / pagination.value.pageSize));

function handleTableChange() {
  pagination.value.current = 1;
  fetchData();
}

function changePage(page) {
  if (page < 1 || page > totalPages.value) return;
  pagination.value.current = page;
  fetchData();
}

function searchKeyword() {
  refetch();
}

function fetchData() {
  refetch();
}

function openModal(record) {
  showModal.value = true;
  initialData.value = record;
}

const totalTournaments = computed(() => pagination.value.total || 0);
const size = computed(() => pagination.value.pageSize || 10);
const current = computed(() => pagination.value.current || 1);
</script>

